export default "__VITE_ASSET__DXZyQZka__"